import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ParticleExplosion } from './ParticleExplosion';

export function FeedbackCompletion({ answers, stats, showParticles }) {
  const navigate = useNavigate();
  const val = answers.value_score || 5;
  let personalNote = "Your honest feedback helps us get to where we need to be. Thank you.";
  if (val >= 8) personalNote = "You are exactly the kind of user we are building for. Thank you.";
  else if (val <= 4) personalNote = "Your critical feedback is the most valuable of all. Thank you for being honest.";

  return (
    <div className="min-h-screen bg-[#060C18] flex items-center justify-center px-4">
      <ParticleExplosion active={showParticles} />
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.5, duration: 0.8 }}
        className="text-center max-w-lg z-10"
      >
        <div className="text-7xl font-bold bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent mb-2" style={{ fontFamily: 'Space Grotesk' }}>
          π
        </div>
        <h1 className="text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Space Grotesk' }}>Thank you.</h1>
        <p className="text-lg text-white/60 mb-8">You are one of our first 500 users.</p>
        <p className="text-white/50 mb-8 leading-relaxed">Your answers will be read carefully and will directly shape what SendPI becomes. Every feature we build next, every problem we fix, every decision we make — your feedback influences it.</p>
        <div className="bg-white/5 rounded-xl p-6 mb-8 text-left space-y-2">
          <div className="flex justify-between text-sm"><span className="text-white/50">Total PI Checks</span><span className="text-white">{stats.pi_checks || 0}</span></div>
          <div className="flex justify-between text-sm"><span className="text-white/50">Days using SendPI</span><span className="text-white">{stats.days_since_signup || 0}</span></div>
          <div className="flex justify-between text-sm"><span className="text-white/50">Your value score</span><span className="text-white">{answers.value_score || 5}/10</span></div>
        </div>
        <p className="text-white/40 text-sm italic mb-8">{personalNote}</p>
        <button
          data-testid="feedback-done-btn"
          onClick={() => navigate('/dashboard')}
          className="px-8 py-3 bg-gradient-to-r from-violet-600 to-cyan-500 text-white rounded-xl font-semibold hover:opacity-90"
        >
          Back to SendPI →
        </button>
      </motion.div>
    </div>
  );
}
